import { ref, watch } from 'vue'
import store from '@/store';

const dados = ref([])
dados.value = store.getters['dados/dados'];


export const getMenuData = [
    // VB:REPLACE-START:MENU-CONFIG
    {
        title: 'Dashboard',
        key: '__dashboard',
        url: '/Dashboard',
        icon: 'fe fe-home',
        disabled: false,
        newTab: false,
    },

    // VB:REPLACE-END:MENU-CONFIG

    {
        title: 'Tarefas por realizar',
        key: 'minhas-tarefas',
        url: '/Tarefas/lista-tarefas',
        icon: 'fe fe-bell',
        disabled: false,
        newTab: false,
        showDrop: false,
        count: ref(0),
        children: [
            {
                title: 'Realizar tarefa',
                key: 'realizar-tarefa',
                url: '/tarefas/ver-tarefa',
                icon: 'fe fe-list',
                disabled: true,
                newTab: false,
            },
        ],
    },

    {
        title: 'Recursos Humanos',
        key: 'rh',
        icon: 'fe fe-users',
        disabled: false,
        children: [
            {
                title: 'Novo pedido',
                key: 'rh-novo-pedido',
                url: '/Rh/Pedidos/lista-novos-pedidos',
                newTab: false,
                disabled: false,
                showDrop: false,
                children: [
                    {
                        title: 'Férias - Pedido de férias',
                        key: 'PedidoPedidoFerias',
                        url: '/Rh/Pedidos/lista-novos-pedidos/ferias',
                        newTab: false,
                        disabled: true,
                    },
                    {
                        title: 'Férias - Alterar/Cancelar férias',
                        key: 'NovoPedidoAlteracaoFerias',
                        url: '/Rh/Pedidos/lista-novos-pedidos/alteracao-ferias',
                        newTab: false,
                        disabled: true,
                    },
                    {
                        title: 'Faltas - Comunicação de faltas ao trabalho',
                        key: 'PedidoComunicacaoFaltas',
                        url: '/Rh/Pedidos/lista-novos-pedidos/faltas',
                        newTab: false,
                        disabled: true,
                    },
                    {
                        title: 'Faltas - Comunicação de faltas ao trabalho por conta das férias',
                        key: 'PedidoComunicacaoFaltasFerias',
                        url: '/Rh/Pedidos/lista-novos-pedidos/faltas-feria',
                        newTab: false,
                        disabled: true,
                    },
                    {
                        title: 'Faltas - Comunicação de faltas ao trabalho por doença',
                        key: 'PedidoComunicacaoFaltasDoenca',
                        url: '/Rh/Pedidos/lista-novos-pedidos/faltas-doenca',
                        newTab: false,
                        disabled: true,
                    },
                    {
                        title: 'Faltas - Compensação do trabalho prestado em acréscimo',
                        key: 'NovoPedidoApresentacaoServico',
                        url: '/Rh/Pedidos/lista-novos-pedidos/faltas-compensacao-tempo',
                        newTab: false,
                        disabled: true,
                    },
                    {
                        title: 'Faltas - Apresentação ao Serviço',
                        key: 'NovoPedidoApresentacaoServico',
                        url: '/Rh/Pedidos/lista-novos-pedidos/apresentacao-servico',
                        newTab: false,
                        disabled: true,
                    },
                    {
                        title: 'Faltas - Comunicação de Faltas Injustificadas',
                        key: 'PedidoComunicacaoFaltasInjustificadas',
                        url: '/Rh/Pedidos/lista-novos-pedidos/faltas-injustificadas',
                        newTab: false,
                        disabled: true,
                    },


                    {
                        title: 'Autorização para realização de trabalho suplementar',
                        key: 'PedidoTrabalhoSuplementar',
                        url: '/Rh/Pedidos/lista-novos-pedidos/trabalho-suplementar',
                        newTab: false,
                        disabled: true,
                    },
                    {
                        title: 'Autorização para realização de trabalho suplementar - Urgente',
                        key: 'PedidoTrabalhoSuplementarUrgente',
                        url: '/Rh/Pedidos/lista-novos-pedidos/trabalho-suplementar-urgente',
                        newTab: false,
                        disabled: true,
                    },


                    {
                        title: 'Autorização de acumulação de funções',
                        key: 'NovoPedidoAcumulacaoFuncoes',
                        url: '/Rh/Pedidos/lista-novos-pedidos/acumulacao-funcoes',
                        newTab: false,
                        disabled: true,
                    },
                    {
                        title: 'Alteração da Autorização de Acumulação de Funções',
                        key: 'NovoPedidoAcumulacaoFuncoesAlteracao',
                        url: '/Rh/Pedidos/lista-novos-pedidos/acumulacao-funcoes-alteracao',
                        newTab: false,
                        disabled: true,
                    },
                    {
                        title: 'Comunicação - Cessação de Acumulação de Funções',
                        key: 'NovoPedidoAcumulacaoFuncoesCessacao',
                        url: '/Rh/Pedidos/lista-novos-pedidos/acumulacao-funcoes-cessacao',
                        newTab: false,
                        disabled: true,
                    },

                    {
                        title: 'Comunicação - Gozo de Descanso Compensatório por Prestação de Trabalho ao Domingo',
                        key: 'NovoPedidoComunicacaoDescasoCompensatorioTrabDomingo',
                        url: '/Rh/Pedidos/lista-novos-pedidos/descanso-compensatorio-trab-domingo',
                        newTab: false,
                        disabled: true,
                    },

                    {
                        title: 'Formação Profissional',
                        key: 'NovoPedidoFormacaoProfissional',
                        url: '/Rh/Pedidos/lista-novos-pedidos/formacao-profissional',
                        newTab: false,
                        disabled: true,
                    },

                    {
                        title: 'Proteção Parentalidade',
                        key: 'NovoPedidoProtecaoParentalidade',
                        url: '/Rh/Pedidos/lista-novos-pedidos/protecao-parentalidade',
                        newTab: false,
                        disabled: true,
                    },

                    {
                        title: 'Ajudas de Custo e Transporte',
                        key: 'NovoPedidoAjudasCustoTransporte',
                        url: '/Rh/Pedidos/lista-novos-pedidos/ajudas-custo_transporte',
                        newTab: false,
                        disabled: true,
                    },


                ],
                
            },
            {
                title: 'Mapa de férias',
                key: 'mapa-ferias',
                url: '/Rh/mapa-ferias',
                newTab: false,
                disabled: false,
            },
            {
                title: 'Mapa de férias por unidade',
                key: 'mapa-ferias-v2',
                url: '/Rh/mapa-ferias-v2',
                disabled: false,
                newTab: false,
            },
            {
                title: 'Assiduidade',
                key: 'assiduidade',
                url: 'https://assiduidade.cm-pombal.pt/',
                disabled: false,
                newTab: true,
            },
            {
                title: 'Minhas Informações',
                key: 'minhas-informacoes',
                url: '/Rh/minhas-informacoes',
                disabled: false,
                newTab: false,
            },
        ],
    },  

    {
        title: 'Pedidos realizados',
        key: 'meus-pedidos',
        url: '/meuspedidos/Pedidos',
        icon: 'fe fe-list',
        disabled: false,
        newTab: false,
        showDrop: false,
        children: [
            {
                title: 'Ver pedido',
                key: 'ver-pedido',
                url: '/meuspedidos/VerPedido',
                icon: 'fe fe-list',
                disabled: true,
                newTab: false,
            },
        ],
    },

    /*
    // em desenvolvimento / em principio esta função foi abandonada
    {
        title: 'Escolas',
        key: 'escolas',
        icon: 'fe fe-book-open',
        disabled: false,
        role: "PC_RA",
        children: [
            {
                title: 'Registo de ausências',
                key: 'escolas-registo-ausencias',
                url: '/Escolas/escolas-registo-ausencias',
                role: "PC_RA",
                disabled: false,
                newTab: false,
            },
        ],
    },
    */

    /*   
    {
        title: 'Ver pedido',
        key: 'ver-pedido',
        url: '/meuspedidos/VerPedido',
        icon: 'fe fe-list',
        disabled: false,
        newTab: false,

    },
    */
]

// função para actualizar o campo contador de tarefs
export function atualizarMenuCount() {
    //const dados = store.getters['dados/dados'];
    getMenuData[1].count.value = dados.value.numeroTarefas; // Atualiza apenas o campo necessário
}

// quando o valor do campo numeroTarefas é alterado no store, actualiza o valor no menu
watch(
    //() => store.state.dados.numeroTarefas,
    () => dados.value.numeroTarefas,
    () => {
        atualizarMenuCount();
    },
    { immediate: true },
)